import BuyButtonMini from '@components/BuyButtonMini';
import { preparePriceFloatObject } from '@utils/floatNumbers';
import type { FC } from 'react';
import { Link } from '@compat/router';
import './index.scss';
import Picture from '../Picture';
import { FreezeIcon } from '../FreezeIcon';
import icons from '@icons';

const {
  star: { yellow: starFilledYellow, grey: starFilledGrey }
} = icons.Fill;

interface ReplaceCardProductProps {
  item: any;
  title: string;
  openQuickInfoModal: () => void;
  isDesktop: boolean;
}

const ReplaceCardProduct: FC<ReplaceCardProductProps> = ({
  item,
  title,
  openQuickInfoModal,
  isDesktop
}) => {
  const priceMeasure =
    item.priceBlockWeightPrice &&
    item.vesovoi === 'Y' &&
    (item.measureItem?.symbol === 'кг' || item?.measure_id !== 2)
      ? `/${item.measureItem.symbol}`
      : '';
  const currentPriceField = item.priceBlockWeightPrice
    ? item.currentPriceField
    : item.currentPriceField2;
  const priceFloatObj = preparePriceFloatObject(currentPriceField);
  return (
    <div key={item.id} className='replace-item-card2'>
      <div className='left-part'>
        <div
          onClick={isDesktop ? openQuickInfoModal : () => {}}
          className='image-block1'
        >
          <img src={item.mainImage} alt={item.title} />
          {item.war_id === 3 && <FreezeIcon height={16} />}
        </div>

        <div className='product-card-new__rating-wrapper'>
          <Picture
            icon={item.comments_number > 0 ? starFilledYellow : starFilledGrey}
            height='14'
            className='product-card-new__star'
          />
          {item.comments_number > 0 && (
            <div className='product-card-new__replaced'>
              {item.rating_comments}
            </div>
          )}
        </div>
      </div>

      <div className='right-part'>
        {isDesktop ? (
          <div onClick={openQuickInfoModal} className='name'>
            {title}
          </div>
        ) : (
          <Link to={`/product/${item.id}`} className='name'>
            {title}
          </Link>
        )}
        <div className='price-block'>
          <div className='product__price-wrapper item-price'>
            {item.oldPriceField > 0 && (
              <div className='product__old-price'>
                {item.oldPriceField}&nbsp;₽{priceMeasure}
              </div>
            )}

            {currentPriceField > 0 && (
              <div
                className='product__current-price'
                style={item.oldPriceField > 0 ? { color: '#B32442' } : {}}
              >
                {priceFloatObj?.wholePart}
                {priceFloatObj?.floatPart && (
                  <span className='product__current-price__decimal'>
                    ,{priceFloatObj?.floatPart}
                  </span>
                )}{' '}
                <span className='product__current-price__ruble'>₽</span>
                {priceMeasure}
              </div>
            )}
          </div>
          <BuyButtonMini productId={item?.id} isReplace />
        </div>
      </div>
    </div>
  );
};

export default ReplaceCardProduct;
